/**
 * Created by Mikhail Menshenin on 28.10.2025
 */

cleverapps.override(cleverapps.Tool.game, {
    "toggle game stats": {
        flag: "statsShow"
    }
});
